import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import ResponsiveGrid from "../generic/ResponsiveGrid";
import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
} from "@mui/material";
import ModalGeneric from "../generic/ModalGeneric";
import { utilityService } from "../../_services";
import VehicleDetailHeaderSummaryDisplay from "./VehicleDetailHeaderSummaryDisplay";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import useHasRole from "../../_hooks/useHasRole";

export default function VehicleDetailDates(props) {
  const vehicle = props.item;
  const [showDotTimers, setShowDotTimers] = useState(false);
  const [modalAddTimerOpen, setModalAddTimerOpen] = useState(false);
  const [modalAddTimerType, setModalAddTimerType] = useState(null);
  const [modalAddTimerDate, setModalAddTimerDate] = useState(null);
  const hasUserRepo = useHasRole("user_repo");
  const isAdmin = useSelector((state) =>
    state.authentication.webUser.roleid === 2 ? true : false
  );
  const titleStatuses = props.titleStatuses;

  if (!vehicle.vehiclevin) {
    return <div>Loading...</div>;
  }

  const addDotTimer = (timerType, timerDate) => {
    console.log({ timerType, timerDate });
    utilityService.addUtility("vehicle_timers", {
      vehicle_id: vehicle.id,
      category: "dot",
      type: timerType,
      date: timerDate,
    });
    setModalAddTimerDate(null);
    setModalAddTimerType(null);
  };

  return (
    <>
      <ModalGeneric
        open={modalAddTimerOpen}
        onClose={() => {
          addDotTimer(modalAddTimerType, modalAddTimerDate);
          setModalAddTimerOpen(false);
        }}
        onCancel={() => {
          setModalAddTimerOpen(false);
        }}
        closeText={
          modalAddTimerType === "stop"
            ? "Add DOT Stop Timer"
            : "Add DOT Start Timer"
        }
        cancelText="Cancel"
        title={
          modalAddTimerType === "stop"
            ? "Add DOT Stop Timer"
            : "Add DOT Start Timer"
        }
      >
        <DatePicker
          slotProps={{ field: { clearable: true } }}
          margin="normal"
          disabled={!isAdmin}
          name="modalTimerDate"
          label={
            modalAddTimerType === "stop" ? "DOT Stop Timer" : "DOT Start Timer"
          }
          format="MM/DD/YYYY"
          value={modalAddTimerDate ? dayjs(modalAddTimerDate) : null}
          onChange={(date) => {
            setModalAddTimerDate(date ? date.format("YYYY-MM-DD") : null);
          }}
        />
        <Typography
          variant="body1"
          style={{ color: "red", fontWeight: "bold" }}
        >
          Save Vehicle Record after adjusting Timers
        </Typography>
      </ModalGeneric>
      <VehicleDetailHeaderSummaryDisplay
        vehicle={{
          vin: props?.item?.vehiclevin,
          year: props?.item?.yr,
          make: props?.item?.make,
          model: props?.item?.model,
        }}
        titleStatus={props?.item?.title_status?.statusname}
        timeInLatestStatus={props?.item?.time_in_latest_status}
        latestNote={props?.item?.latest_note?.note}
      />
      <TextField
        margin="dense"
        name={"entered_by_user"}
        label={"Entered by Person"}
        type="text"
        disabled={!isAdmin}
        value={vehicle.entered_by_user ? vehicle.entered_by_user.name : ""}
        readOnly
        style={{ width: "50%" }}
      />
      <TextField
        margin="dense"
        name={"recordcreateddate"}
        label={"Date entered into system"}
        type="text"
        value={
          vehicle.recordcreateddate
            ? moment(vehicle.recordcreateddate).format("M/D/Y")
            : ""
        }
        // onChange={handleChangeAuctionData}
        readOnly
        style={{ width: "50%" }}
      />
      <FormControl fullWidth>
        <InputLabel shrink>Vehicle Status</InputLabel>
        <Select
          native
          value={vehicle.titlestatusid || 1}
          onChange={props.onUpdateLocal}
          displayEmpty
          disabled={!isAdmin}
          name="titlestatusid"
        >
          {titleStatuses.map((item) => {
            return (
              <option key={item.statusid} value={item.statusid}>
                {item.statuscode} - {item.statusname}
              </option>
            );
          })}
        </Select>
      </FormControl>
      <br />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        disabled={!isAdmin && !hasUserRepo}
        name="repossessiondate"
        label="Repo/Sale Date"
        format="MM/DD/YYYY"
        value={
          vehicle.repossessiondate ? dayjs(vehicle.repossessiondate) : null
        }
        onChange={(date, value) => {
          props.onUpdateLocalExplicit(
            "repossessiondate",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin && !hasUserRepo}
        name="dateoflien"
        label="Date of Lien"
        format="MM/DD/YYYY"
        value={vehicle.dateoflien ? dayjs(vehicle.dateoflien) : null}
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "dateoflien",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <br />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="titleregownershipdate"
        label="Title Ownership Date"
        format="MM/DD/YYYY"
        value={
          vehicle.titleregownershipdate
            ? dayjs(vehicle.titleregownershipdate)
            : null
        }
        onChange={(date) => {
          props.onUpdateLocalExplicit(
            "titleregownershipdate",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="title_reg_ownership_scan_date"
        label="Title Scan Ownership Date"
        format="MM/DD/YYYY"
        value={
          vehicle.title_reg_ownership_scan_date
            ? dayjs(vehicle.title_reg_ownership_scan_date)
            : null
        }
        onChange={(date) => {
          props.onUpdateLocalExplicit(
            "title_reg_ownership_scan_date",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="scanned_7501_date"
        label="7501 Scan Date"
        format="MM/DD/YYYY"
        value={
          vehicle.scanned_7501_date ? dayjs(vehicle.scanned_7501_date) : null
        }
        onChange={(date) => {
          props.onUpdateLocalExplicit(
            "scanned_7501_date",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="sent_7501_date"
        label="7501 Sent Date"
        format="MM/DD/YYYY"
        value={vehicle.sent_7501_date ? dayjs(vehicle.sent_7501_date) : null}
        onChange={(date) => {
          props.onUpdateLocalExplicit(
            "sent_7501_date",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <br />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="titlesenttobmvdate"
        label="Title sent to BMV Date"
        format="MM/DD/YYYY"
        value={
          vehicle.titlesenttobmvdate ? dayjs(vehicle.titlesenttobmvdate) : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "titlesenttobmvdate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="state_white_copy_date"
        label="Title White Copy Received"
        format="MM/DD/YYYY"
        value={
          vehicle.state_white_copy_date
            ? dayjs(vehicle.state_white_copy_date)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "state_white_copy_date",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="titlebackfrombmvdate"
        label="Title back from BMV Date"
        format="MM/DD/YYYY"
        value={
          vehicle.titlebackfrombmvdate
            ? dayjs(vehicle.titlebackfrombmvdate)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "titlebackfrombmvdate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        style={{ width: 400 }}
        margin="normal"
        disabled={!isAdmin}
        name="titlesenttoauctiondate"
        label="Title Sent to Client/Auction Date"
        format="MM/DD/YYYY"
        value={
          vehicle.titlesenttoauctiondate
            ? dayjs(vehicle.titlesenttoauctiondate)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "titlesenttoauctiondate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <br />
      <Button
        onClick={() => {
          setModalAddTimerType("stop");
          setModalAddTimerOpen(true);
        }}
        variant="contained"
        style={{ backgroundColor: "red" }}
        disabled={!isAdmin}
      >
        DOT Stop Timer
      </Button>{" "}
      <Button
        onClick={() => {
          setModalAddTimerType("start");
          setModalAddTimerOpen(true);
        }}
        variant="contained"
        style={{ backgroundColor: "green" }}
        disabled={!isAdmin}
      >
        DOT Resume Timer
      </Button>{" "}
      <Typography style={{ display: "inline" }}>
        DOT Timer Status: {!vehicle.dot_vault_date && "Standard 30 days"}
        {vehicle.dot_vault_date?.status === "stopped" && "Stopped"}
        {vehicle.dot_vault_date?.status === "extended" &&
          `Extended ${vehicle.dot_vault_date?.extended} days`}
      </Typography>{" "}
      <Button
        onClick={() => setShowDotTimers(!showDotTimers)}
        variant="contained"
        color="primary"
      >
        Toggle Timers
      </Button>
      {showDotTimers && (
        <div>
          {vehicle.dot_timers.map((timer) => (
            <div key={String(timer.id)}>
              {moment(timer.date).format("YYYY-MM-DD")} {timer.type}
            </div>
          ))}
        </div>
      )}
      <br />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="submittedtocustomsdate"
        label="Submitted to Customs Date"
        format="MM/DD/YYYY"
        value={
          vehicle.submittedtocustomsdate
            ? dayjs(vehicle.submittedtocustomsdate)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "submittedtocustomsdate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="crossedborderdate"
        label="Crossed Border Date"
        format="MM/DD/YYYY"
        value={
          vehicle.crossedborderdate ? dayjs(vehicle.crossedborderdate) : null
        }
        onChange={(date) => {
          props.onUpdateLocalExplicit(
            "crossedborderdate",
            date ? date.format("YYYY-MM-DD") : null
          );
          if (date === "Invalid Date" || date === null) {
            return;
          }
          props.onUpdateLocalExplicit(
            "repossessiondate",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="confirmedladeddate"
        label="Confirm Landed Date"
        format="MM/DD/YYYY"
        value={
          vehicle.confirmedladeddate ? dayjs(vehicle.confirmedladeddate) : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "confirmedladeddate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="dot_inspection_date"
        label="DOT Signoff Date"
        format="MM/DD/YYYY"
        value={
          vehicle.dot_inspection_date
            ? dayjs(vehicle.dot_inspection_date)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "dot_inspection_date",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={Number(vehicle.is_dot_resubmit) === 1}
              onChange={(event) => {
                props.onUpdateLocalExplicit(
                  "is_dot_resubmit",
                  event.target.checked ? 1 : 0
                );
                if (event.target.checked) {
                  props.onUpdateLocalExplicit(
                    "dot_resubmit_date",
                    moment().format("Y-M-D")
                  );
                } else {
                  props.onUpdateLocalExplicit("dot_resubmit_date", null);
                }
              }}
              name="is_dot_resubmit"
            />
          }
          label="DOT Resub"
        />
      </FormGroup>
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="submitteddotdate"
        label="DOT Submitted Date"
        format="MM/DD/YYYY"
        value={
          vehicle.submitteddotdate ? dayjs(vehicle.submitteddotdate) : null
        }
        onChange={(date) => {
          const date1 = date;
          const date2 = date;
          props.onUpdateLocalExplicit(
            "submitteddotdate",
            date ? date.format("YYYY-MM-DD") : null
          );
          if (date === "Invalid Date" || date === null) {
            return;
          }
          props.onUpdateLocalExplicit(
            "vaultreleasedate",
            date1.add(30, "days").format("YYYY-MM-DD")
          );

          let daysToAdd = 21;
          if (
            vehicle.client &&
            vehicle.client.defaults &&
            vehicle.client.defaults.vehicle_release_days
          ) {
            daysToAdd = vehicle.client.defaults.vehicle_release_days;
          }
          props.onUpdateLocalExplicit(
            "vehicleinspectiondate",
            date2.add(daysToAdd, "days").format("YYYY-MM-DD")
          );
        }}
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="dot_resubmit_date"
        label="DOT Resub Date"
        format="MM/DD/YYYY"
        value={
          vehicle.dot_resubmit_date ? dayjs(vehicle.dot_resubmit_date) : null
        }
        onChange={(date, value) => {
          props.onUpdateLocalExplicit(
            "dot_resubmit_date",
            date ? date.format("YYYY-MM-DD") : null
          );
        }}
      />
      <br />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="vehicleinspectiondate"
        label="Final Inspection Date"
        format="MM/DD/YYYY"
        value={
          vehicle.vehicleinspectiondate
            ? dayjs(vehicle.vehicleinspectiondate)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "vehicleinspectiondate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="vaultreleasedate"
        label="Vault Release Date"
        format="MM/DD/YYYY"
        value={
          vehicle.vaultreleasedate ? dayjs(vehicle.vaultreleasedate) : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "vaultreleasedate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="bondreleasedate"
        label="Bond Release Date"
        format="MM/DD/YYYY"
        value={vehicle.bondreleasedate ? dayjs(vehicle.bondreleasedate) : null}
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "bondreleasedate",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <br />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="speedo_pulled_date"
        label="Speedo Pulled Date"
        format="MM/DD/YYYY"
        value={
          vehicle.speedo_pulled_date ? dayjs(vehicle.speedo_pulled_date) : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "speedo_pulled_date",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="speedo_shipped_date"
        label="Speedo Shipped Date"
        format="MM/DD/YYYY"
        value={
          vehicle.speedo_shipped_date
            ? dayjs(vehicle.speedo_shipped_date)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "speedo_shipped_date",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="speedo_received_date"
        label="Speedo Received Date"
        format="MM/DD/YYYY"
        value={
          vehicle.speedo_received_date
            ? dayjs(vehicle.speedo_received_date)
            : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "speedo_received_date",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="speedo_placed_date"
        label="Speedo Placed Date"
        format="MM/DD/YYYY"
        value={
          vehicle.speedo_placed_date ? dayjs(vehicle.speedo_placed_date) : null
        }
        onChange={(date) =>
          props.onUpdateLocalExplicit(
            "speedo_placed_date",
            date ? date.format("YYYY-MM-DD") : null
          )
        }
      />
      <Divider />
      <Typography variant="h6" align="center">
        Notes
      </Typography>
      <ResponsiveGrid
        usePagination={false}
        columns={[
          {
            title: "Date",
            width: 4,
            field: "notedate",
            dataRender: (item) => moment(item.notedate).format("M/D/Y h:mm:ss"),
          },
          { title: "Note", width: 4, field: "note" },
          { title: "User", width: 4, field: "user.name" },
        ]}
        data={vehicle.notes}
      />
      <Divider />
      <Typography variant="h6" align="center">
        Activity
      </Typography>
      <ResponsiveGrid
        usePagination={false}
        columns={[
          {
            title: "Date",
            width: 4,
            field: "activitytimedate",
            dataRender: (item) =>
              moment(item.activitytimedate).format("M/D/Y h:mm:ss"),
          },
          { title: "Activity", width: 4, field: "type.activitytype" },
          { title: "User", width: 4, field: "user.name" },
        ]}
        data={vehicle.activity}
      />
    </>
  );
}
